export default __webpack_public_path__ + "static/why-mvp-wireframes-65157ffd450f49d1778429392a1cd861.jpg";